import { useEffect, useState } from "react";
import expAcademicaServices from "./../../../services/alumnos/expAcademicaServices";
import functions from "./../../../shared/functions";
import { message } from 'antd';

import dayjs from "dayjs";

const useExpAcademica = (initialData = []) => {

    const [data, setData] = useState(initialData);
    const [editing, setEditing] = useState(null);
    const [newData, setNewData] = useState(false);
    const [loading, setLoading] = useState(false);
    const [catalogos, setCatalogos] = useState([]);

    const fetchData = async () => {
        setLoading(true);
        const response = await expAcademicaServices.getExpAcademicaMe()
        setLoading(false);
        if (!response.success) return;
        setData(functions.ordenarPorFechaInicial(response.data));
    };

    const fetchCatalogos = async () => {
        setLoading(true);
        const response = await expAcademicaServices.getCatalogos()
        setLoading(false);
        if (!response.success) return;
        setCatalogos(response.data);
    };

    useEffect(() => {
        fetchCatalogos();
    }, []);

    useEffect(() => { 
        setData(functions.ordenarPorFechaInicial(initialData));
    }, [initialData]);

    const startEdit = (editing) => {
        const clone_record = { ...editing };

        // Separar la fecha de inicio y la fecha de fin, y convertirlas a objetos 'dayjs' si son válidas; 
        // si no son válidas, se asigna 'null' a la fecha de fin.
        const [startDate, endDate] = clone_record.fecha.split('|').map(date => dayjs(date, 'YYYY-MM-DD').isValid() ? dayjs(date, 'YYYY-MM-DD') : null);
        setEditing({ ...clone_record, fecha: [startDate, endDate || null] });
    };

    const cancelEdit = () => {
        setEditing(null);
        setNewData(false);
    };

    const saveRecord = async (record) => {
        
        const format_date = `${record?.fecha[0]?.format('YYYY-MM-DD')}|${record?.fecha[1]?.isValid() ? record?.fecha[1]?.format('YYYY-MM-DD') : 'Actual'}`; 

        if (!record.id_expAca && !editing) {
            record.fecha = format_date
            const response = await expAcademicaServices.createExpAcademicaMe(record);
            if (!response.success) return false;
            message.success('Guardado correctamente');
        } else {
            record.fecha = format_date
            record.id_expAca = editing?.id_expAca;

            const response = await expAcademicaServices.editExpAcademicaMe(record);
            if (!response.success) return false;
            message.success('Editado correctamente');
        }
        setEditing(null);
        await fetchData();
        return true;
    };

    const deleteRecord = async (record) => {
        const response = await expAcademicaServices.deleteExpAcademicaMe(record?.id_expAca);
        if (!response.success) return;

        message.success('Experiencia académica eliminada correctamente');
        await fetchData();
    };

    return { data, newData, setNewData, editing, startEdit, cancelEdit, saveRecord, deleteRecord, loading, fetchData, catalogos };

}


export default useExpAcademica